"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BasePropertyInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _ConnectReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ConnectReferenceResolvers"));

var _guids = require("reporting-data/lib/guids");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ExternalOptionTypes = require("customer-data-objects/property/ExternalOptionTypes");

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _PropertyIdentifier = require("customer-data-objects/property/PropertyIdentifier");

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _PropertyInputResolvers = require("customer-data-properties/resolvers/PropertyInputResolvers");

var Inputs = _interopRequireWildcard(require("./PropertyInputs"));

var _ProvideReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ProvideReferenceResolvers"));

var _fromJS;

var autocompletes = {
  associatedcompanyid: true,
  'associations.company': true,
  hs_parent_company_id: true,
  salesforcecampaignids: true,
  'listMemberships.listId': true,
  hs_analytics_first_touch_converting_campaign: true,
  hs_analytics_last_touch_converting_campaign: true
};
var DATA_1 = 'hs_analytics_source_data_1';
var DATA_2 = 'hs_analytics_source_data_2';
var KNOWN_GUID_FIELDS = (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _ObjectTypes.VISIT, ['sourceData1', 'sourceData2']), (0, _defineProperty2.default)(_fromJS, _ObjectTypes.CONTACT, [DATA_1, DATA_2]), _fromJS));

var isImport = function isImport(subject) {
  return (0, _ObjectRecordAccessors.getProperty)(subject, DATA_1) === _PropertySourceTypes.IMPORT;
};

var isIntegration = function isIntegration(subject) {
  return (0, _ObjectRecordAccessors.getProperty)(subject, DATA_1) === _PropertySourceTypes.INTEGRATION;
};

var getResolverTypeForProperty = function getResolverTypeForProperty(_ref) {
  var subject = _ref.subject,
      property = _ref.property,
      objectType = _ref.objectType;
  return (0, _PropertyInputResolvers.getPropertyInputResolverType)(property, objectType, {
    isImport: isImport(subject),
    isIntegration: isIntegration(subject)
  });
};

var selectResolver = function selectResolver(resolvers, props) {
  return (0, _PropertyInputResolvers.mapDefaultResolverToPropertyInput)(getResolverTypeForProperty(props), resolvers, props);
};

var isAssociatedCompany = function isAssociatedCompany(property, objectType) {
  return property.name === 'associatedcompanyid' && objectType === _ObjectTypes.CONTACT || property.name === 'hs_parent_company_id' && objectType === _ObjectTypes.COMPANY;
};

var isDealPipeline = function isDealPipeline(property, objectType) {
  return property.name === 'pipeline' && objectType === _ObjectTypes.DEAL;
};

var isDealStage = function isDealStage(property, objectType) {
  return objectType === _ObjectTypes.DEAL && property.name === 'dealstage';
};

var isMultiCurrencyCurrencyCode = function isMultiCurrencyCurrencyCode(property) {
  return property.name === 'deal_currency_code';
};

var isTicketPipeline = function isTicketPipeline(property, objectType) {
  return objectType === _ObjectTypes.TICKET && property.name === 'hs_pipeline';
};

var isTicketStage = function isTicketStage(property, objectType) {
  return objectType === _ObjectTypes.TICKET && property.name === 'hs_pipeline_stage';
};

var isTicketPriority = function isTicketPriority(property) {
  return property.name === 'hs_ticket_priority';
};

var isContactEmail = function isContactEmail(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && property.name === 'email';
};

var isPersona = function isPersona(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && property.name === 'hs_persona';
};

var isOwner = function isOwner(property) {
  return ['hubspot_owner_id', 'engagement.ownerId'].includes(property.name) || property.referencedObjectType === _ExternalOptionTypes.OWNER;
};

var isCreateCloseDate = function isCreateCloseDate(property, objectType) {
  return objectType === _ObjectTypes.DEAL && (property.name === 'createdate' || property.name === 'closedate') || objectType === _ObjectTypes.TICKET && (property.name === 'createdate' || property.name === 'closed_date');
};

var isDomain = function isDomain(property) {
  return property.name === 'domain';
};

var isGuidFieldWithKnownGuid = (0, _memoize.default)(function (property, value, objectType) {
  var guidFiledsForType = KNOWN_GUID_FIELDS.get(objectType);

  if (!guidFiledsForType) {
    return false;
  }

  return guidFiledsForType.includes(property.name) && !!value && (0, _guids.isKnownGuid)(value);
});

var isEnum = function isEnum(property) {
  if (['enumeration', 'bool'].includes(property.type)) {
    return true;
  }

  if (autocompletes[property.name]) {
    return true;
  }

  return false;
};

var isDuration = function isDuration(property, objectType) {
  return property.name.startsWith('hs_time_in_') || objectType === _ObjectTypes.TICKET && (property.name === 'time_to_first_agent_reply' || property.name === 'time_to_close');
};

var isName = function isName(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && ['firstname', 'lastname'].includes(property.name);
};

var isFileUpload = function isFileUpload(property) {
  return property.name === 'file_upload_';
};

var propTypes = {
  actions: (0, _reactImmutableProptypes.mapOf)(_react.PropTypes.object, _react.PropTypes.string),
  autoFocus: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  componentResolver: _react.PropTypes.func,
  id: _react.PropTypes.string,
  isInline: _react.PropTypes.bool.isRequired,
  isExpandableTextInputEnabled: _react.PropTypes.bool,
  objectType: _ObjectTypesType.default.isRequired,
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  onInvalidProperty: _react.PropTypes.func,
  onKeyUp: _react.PropTypes.func,
  onTracking: _react.PropTypes.func,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  propertyIndex: _react.PropTypes.number,
  readOnly: _react.PropTypes.bool,
  resolver: _react.PropTypes.oneOfType([_ReferenceResolverType.default, (0, _reactImmutableProptypes.mapOf)(_ReferenceResolverType.default)]),
  showError: _react.PropTypes.bool,
  showPlaceholder: _react.PropTypes.bool,
  subject: _SubjectType.default,
  subjectId: _react.PropTypes.string,
  value: _react.PropTypes.node,
  wrappers: (0, _reactImmutableProptypes.mapOf)(_react.PropTypes.node, _react.PropTypes.string),
  componentConfig: _react.PropTypes.object
};
var defaultProps = {
  actions: (0, _immutable.Map)(),
  isInline: false,
  isExpandableTextInputEnabled: false,
  wrappers: (0, _immutable.Map)()
};
var propertiesToOmit = ['isExpandableTextInputEnabled', 'propertyInputComponentConfig', 'componentResolver', 'wrappers', 'onTracking'];

var PropertyInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInput, _React$Component);

  function PropertyInput() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInput).call(this));
    _this.inputRef = (0, _react.createRef)();
    return _this;
  }

  (0, _createClass2.default)(PropertyInput, [{
    key: "focus",
    value: function focus() {
      if (this.inputRef.current && typeof this.inputRef.current.focus === 'function') {
        this.inputRef.current.focus();
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          property = _this$props.property,
          subjectId = _this$props.subjectId;

      if (typeof this.props.componentResolver === 'function') {
        var component = this.props.componentResolver.call(this);

        if (component) {
          return component;
        }
      }

      var type = property.get('type'); // Duration properties are number properties so need to pre empt it.

      if (isDuration(property, objectType)) {
        return Inputs.PropertyInputDuration;
      }

      if ((0, _PropertyIdentifier.isCurrency)(property)) {
        return Inputs.PropertyInputCurrency;
      } // numbers can render their own readonlys


      if (type === 'number') {
        return Inputs.PropertyInputNumber;
      } // enums


      if (isDealPipeline(property, objectType)) {
        return Inputs.PropertyInputDealPipeline;
      }

      if (isDealStage(property, objectType)) {
        return Inputs.PropertyInputDealStage;
      }

      if (isMultiCurrencyCurrencyCode(property)) {
        return Inputs.PropertyInputMultiCurrencyCurrencyCode;
      }

      if (isTicketPipeline(property, objectType)) {
        return Inputs.PropertyInputTicketPipeline;
      }

      if (isTicketStage(property, objectType)) {
        return Inputs.PropertyInputTicketStage;
      }

      if (isTicketPriority(property)) {
        return Inputs.PropertyInputTicketPriority;
      }

      if (isOwner(property)) {
        return Inputs.PropertyInputOwner;
      }

      if (isPersona(property, objectType)) {
        return Inputs.PropertyInputPersona;
      }

      if (isGuidFieldWithKnownGuid(property, this.getValue(), objectType)) {
        return Inputs.PropertyInputKnownGuid;
      }

      if (subjectId && isContactEmail(property, objectType)) {
        return Inputs.PropertyInputMultipleEmail;
      }

      if (this.getIsReadOnly()) {
        if (isFileUpload(property)) {
          return Inputs.PropertyInputFiles;
        }

        return Inputs.PropertyInputReadOnly;
      }

      if (isEnum(property) && (0, _PropertyIdentifier.isMultiple)(property)) {
        return Inputs.PropertyInputEnumMulti;
      }

      if (isEnum(property)) {
        return Inputs.PropertyInputEnum;
      }

      if (isContactEmail(property, objectType)) {
        return Inputs.PropertyInputEmailWrapper;
      }

      if (isAssociatedCompany(property, objectType)) {
        return Inputs.PropertyInputAssociatedCompany;
      }

      if (subjectId && isDomain(property) && objectType === _ObjectTypes.COMPANY) {
        propertiesToOmit = propertiesToOmit.filter(function (p) {
          return p !== 'propertyInputComponentConfig';
        });
        return Inputs.PropertyInputMultiDomain;
      }

      if (isDomain(property)) {
        return Inputs.PropertyInputDomain;
      }

      if (isCreateCloseDate(property, objectType)) {
        return Inputs.PropertyInputCloseCreateDate;
      }

      if ((0, _PropertyIdentifier.isDate)(property)) {
        return Inputs.PropertyInputDate;
      }

      if ((0, _PropertyIdentifier.isTextarea)(property)) {
        return this.props.isExpandableTextInputEnabled ? Inputs.PropertyInputExpandableText : Inputs.PropertyInputTextArea;
      }

      if (isName(property, objectType)) {
        return Inputs.PropertyInputName;
      }

      if (this.props.isExpandableTextInputEnabled) {
        return Inputs.PropertyInputExpandableText;
      } // anything else defaults to `text`


      return Inputs.PropertyInputText;
    }
  }, {
    key: "getIsReadOnly",
    value: function getIsReadOnly() {
      return this.props.readOnly || (0, _PropertyIdentifier.isReadOnly)(this.props.property);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var property = this.props.property;
      var value = this.props.value; // If a value can be read in standard format, do so;
      // otherwise, try local format

      if (property.type === 'number' && !(0, _PropertyIdentifier.isCurrency)(property) && value && property.numberDisplayHint !== 'unformatted') {
        value = isNaN(Number(value)) ? _I18n.default.parseNumber(value, {
          precision: 5
        }) : Number(value);
      }

      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var Wrapper = this.props.wrappers.get(this.props.property.name);
      var Component = this.getComponent();

      if (Wrapper) {
        Component = Wrapper(Component);
      }

      var transferrableProps = (0, _omit.default)(propertiesToOmit, this.props);
      return _react.default.createElement(Component, (0, _extends2.default)({}, transferrableProps, {
        actions: this.props.actions.get(this.props.property.name),
        autoFocus: this.props.autoFocus,
        className: (0, _classNames.default)(this.props.className, {
          isInline: this.props.isInline
        }),
        id: this.props.id,
        isExpandableTextInputEnabled: this.getIsReadOnly() ? this.props.isExpandableTextInputEnabled : undefined,
        "data-field": this.props.property.name,
        objectType: this.props.objectType,
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        onInvalidProperty: this.props.onInvalidProperty,
        onFocus: this.props.onFocus,
        onKeyUp: this.props.onKeyUp,
        propertyIndex: this.props.propertyIndex,
        showError: this.props.showError,
        value: this.getValue(),
        readOnly: this.getIsReadOnly(),
        ref: this.inputRef,
        "data-selenium-test": "property-input-" + this.props.property.name,
        onTracking: this.props.onTracking
      }));
    }
  }]);
  return PropertyInput;
}(_react.default.Component);

PropertyInput.propTypes = propTypes;
PropertyInput.defaultProps = defaultProps;
var BasePropertyInput = (0, _react.memo)(PropertyInput);
exports.BasePropertyInput = BasePropertyInput;
var ConnectedPropertyInput = (0, _ConnectReferenceResolvers.default)(selectResolver, BasePropertyInput, {
  forwardRef: true
});

var _default = (0, _ProvideReferenceResolvers.default)((0, _PropertyInputResolvers.getPropertyInputResolverCreators)(), ConnectedPropertyInput, {
  forwardRef: true,
  mergeResolvers: true
});

exports.default = _default;